import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import ExpansionImage from '../assets/expansion/expansion.jpg';

const t1 = `In line with Saudi Arabia’s Vision 2030, New Era Education has partnered with Palm Hills Development and Dallah El Baraka Group to transform the educational landscape in the Kingdom with a large investment.`;
const t2 = `The scope includes establishing 10-15 premium schools across major Saudi cities, bringing British educational excellence through partnerships with Uppingham, and Moon Hall.`;

const Expansion = () => {

  useEffect(() => {AOS.init({duration: 1000, easing: "ease-in-out", once: true,});}, []);

  return (
    <div className="flex flex-col md:flex-row items-center md:items-start w-full px-6 pb-8 md:px-12 text-blue font-tenor">
  
      {/* Left Side: Text Content */}
      <div className="md:w-2/3 w-full my-auto shadow-lg p-6 md:mr-12" data-aos="fade-right">
      <p className="md:text-3xl text-2xl tracking-tighter md:tracking-normal uppercase mb-4 font-bold text-green">Regional Expansion:</p>
      <p className="md:text-3xl md:uppercase text-lg mb-4 font-bold">Saudi Arabia and Beyond</p>
      <p className="text-sm md:text-base mb-4">{t1}</p>
      <p className="text-sm md:text-base md:mb-0">{t2}</p></div>
      

      {/* Right Side: Image */}
      <div className="md:w-1/3 w-full mt-8 md:mt-0 overflow-hidden" data-aos="fade-left">
      <img src={ExpansionImage} alt="Expansion" className="w-full h-full transition-transform duration-500 ease-in-out transform hover:scale-105 object-cover object-top"/></div></div>);};

export default Expansion;



